import { render, staticRenderFns } from "./intelligentAssistant.vue?vue&type=template&id=1a67ed82&scoped=true&"
import script from "./intelligentAssistant.js?vue&type=script&lang=js&"
export * from "./intelligentAssistant.js?vue&type=script&lang=js&"
import style0 from "./intelligentAssistant.css?vue&type=style&index=0&id=1a67ed82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a67ed82",
  null
  
)

export default component.exports